import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/globals.css';
import { loadSave, attachAutosave } from '@/engine/save';
import { startTickLoop } from '@/engine/tick';
import { useCinematic } from '@/components/CinematicTakeover';
import { useSettings } from '@/state/settings';
import { applyTheme, type ThemeId } from '@/theme/themes';
import { useMeta } from '@/state/meta';
import { useNotifications } from '@/state/notifications';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root');

const { loaded, offlineMs } = loadSave();
attachAutosave();
startTickLoop();

// Apply current theme + react to changes
applyTheme(useSettings.getState().themeId as ThemeId);
useSettings.subscribe((s, prev) => {
  if (s.themeId !== prev.themeId) applyTheme(s.themeId as ThemeId);
  if (s.reducedMotion !== prev.reducedMotion) {
    document.documentElement.classList.toggle('reduced-motion', s.reducedMotion);
  }
});
// Set initial reduced-motion class
if (useSettings.getState().reducedMotion) {
  document.documentElement.classList.add('reduced-motion');
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Welcome-back digest cinematic if it's been a while
if (loaded && offlineMs > 60 * 60 * 1000) {
  const minutes = Math.floor(offlineMs / 60_000);
  const hours = Math.floor(minutes / 60);
  const elapsed = hours > 24 ? `${Math.floor(hours / 24)} days` : hours >= 1 ? `${hours} hours` : `${minutes} minutes`;
  setTimeout(() => {
    useCinematic.getState().fire({
      id: 'welcome-back',
      type: 'welcome-back',
      headline: `${elapsed} have passed.`,
      subhead: 'the markets did not wait. neither did your wife.',
      durationMs: 6000,
    });
  }, 600);
}

// Daily-login streak tracking + bonus
const loginRes = useMeta.getState().registerLogin();
if (loginRes.newDay) {
  setTimeout(() => {
    if (loginRes.bonusCoins > 0) {
      useNotifications.getState().push({
        surfaceId: 'tv',
        severity: 'important',
        text: `🔥 ${loginRes.streak}-day streak. +${loginRes.bonusCoins} Carry Coins.`,
      });
    } else if (loginRes.streak > 1) {
      useNotifications.getState().push({
        surfaceId: 'tv',
        severity: 'info',
        text: `🔥 ${loginRes.streak}-day login streak. keep going.`,
      });
    }
  }, 2500);
}
